import type { ResourcesConfig } from 'aws-amplify';

// Only the user pool + client are configured: they back Amplify's token storage
// and silent refresh. Interactive auth is brokered by the helmsdeep hub
// (ENG-347), which hands Cognito tokens back for us to inject into Amplify — so
// there is no hosted-UI OAuth block (domain / redirect URLs) here.
export const awsConfig: ResourcesConfig = {
   Auth: {
      Cognito: {
         userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
         userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      },
   },
};
